/* eslint-disable import/prefer-default-export */
export const proviedDbTypeMap = {
  MYSQL: 'MYSQL',
  ORACLE: 'ORACLE',
  MSSQL: 'MSSQL',
  TIBERO: 'TIBERO',
  CUBRID: 'CUBRID',
};



// WEBPACK FOOTER //
// ./src/constants/dbms.js